import { render, staticRenderFns } from "./file_Upload.vue?vue&type=template&id=6a0c9019&scoped=true"
import script from "./file_Upload.vue?vue&type=script&lang=js"
export * from "./file_Upload.vue?vue&type=script&lang=js"
import style0 from "./file_Upload.vue?vue&type=style&index=0&id=6a0c9019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c9019",
  null
  
)

export default component.exports